/**
 * Created By: Tyrus Malmstrom
 * Creation Date: 07/29/2022
 * Description:
 *   - Mixin to house specific functionality and logic to create a lottie animation instance.
 */

/* eslint-disable */

// Plugins / Libraries:
import _ from 'lodash';
import bodymovin from 'lottie-web';

export default {
  data() {
    return {
      animation: null,
    };
  },
  computed: {
    /**
     * Specific events for the lottie animation instance.
     */
     lottieAnimationListeners() {
      return {
        'loopComplete': () => {
          // nothing for now...
        },
        'DOMLoaded': () => {
          // nothing for now...
        },
        'complete': () => {
          // nothing for now...
        },
        'config_ready': () => {
          // nothing for now...
        },
        'data_ready': () => {
          // nothing for now...
        },
      };
    },
  },
  methods: {
    createLottieAnimation(options = {}) {
      const {
        container,
        renderer = 'svg',
        loop = true,
        autoplay = true,
        animationData = {},
        name,
        rendererSettings,
      } = options;
      this.animation = bodymovin.loadAnimation({
        container,
        renderer,
        loop,
        autoplay,
        animationData,
        name,
        rendererSettings,
      });
      this.enableLottieAnimationListeners();
      return this.animation;
    },
    enableLottieAnimationListeners() {
      this.disableLottieAnimationListeners();
      if (!_.isObject(this.lottieAnimationListeners) && !_.isNil(this.animation)) return;
      for (const key of Object.keys(this.lottieAnimationListeners)) {
        this.animation.addEventListener(key, this.lottieAnimationListeners[key]);
      }
    },
    disableLottieAnimationListeners() {
      if (!_.isObject(this.lottieAnimationListeners && !_.isNil(this.animation))) return;
      for (const key of Object.keys(this.lottieAnimationListeners)) {
        this.animation.removeEventListener(key, this.lottieAnimationListeners[key]);
      }
    },
    destroyLottieAnimation() {
      this.disableLottieAnimationListeners();
      this.animation.destroy();
    },
  },
  beforeDestroy() {
    if (this.animation) {
      this.destroyLottieAnimation();
    }
  },
};
